import React, { FC } from 'react'
import { makeStyles, Box } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { shadows } from 'transfix-ui'
import { OnboardingCarrierListItem } from './CarrierSearchListItem'
import { ISearchedMotorCarrier } from './types'

const useOnboardingCarrierListStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${brandColors.coolGray4}`,
    boxSizing: 'border-box',
    boxShadow: shadows[1],
    borderRadius: theme.shape.borderRadius,
  },
}))

interface IOnboardingCarrierListProps {
  /**
   * @default []
   */
  carriers: ISearchedMotorCarrier[]
  /**
   * @default true
   */
  isMessageVisible?: boolean
  onRemoveCarrier?: (index: number) => void
}

/**
 * Display component that lists all selected carriers in <OnboardingWizard /> step
 */
export const OnboardingCarrierList: FC<IOnboardingCarrierListProps> = ({
  carriers = [],
  isMessageVisible = true,
  onRemoveCarrier,
}) => {
  const classes = useOnboardingCarrierListStyles()
  return (
    <Box className={carriers.length ? classes.root : ''}>
      {carriers.map(carrier => {
        const index = carriers.indexOf(carrier)
        const { legalName = '' } = carrier || {}
        return (
          <OnboardingCarrierListItem
            key={legalName}
            motorCarrier={carrier}
            index={index}
            onRemoveCarrier={onRemoveCarrier}
            isMessageVisible={isMessageVisible}
          />
        )
      })}
    </Box>
  )
}
